export default __webpack_public_path__ + "static/media/image 16.23d1d0c7.png";